import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { usePoReportModel } from "../poReportModel"
import { HistoryModel } from "@/views/historyModel";
//采购报表
export default () => {
    const {
        historyVisible, setHistoryVisible,
        historyRow
    } = usePoReportModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            <HistoryModel
                visible={historyVisible}
                materialCode={historyRow?.materialCode as string}
                materialName={historyRow?.materialName as string}
                onCancel={() => setHistoryVisible(false)}
            />
        </>
    )
}